export const getAvatarCompanyName = (name: string): string => {
  const ignoreWords = ['and', 'the', 'of']

  const words = name
    .split(/[\s,]+/)
    .filter(word => word && !ignoreWords.includes(word.toLowerCase()))

  const initials = words.slice(0, 2).map(word => word[0].toUpperCase())

  return initials.join('')
}
